import axios from "axios";
import encrypt from '../utils/crypto-util';
import router from '../router/generated_router';
import { clearUserMenuRoutes } from '../utils/dynamicRoutes';
import { useFormStateStore } from '../stores/formState';
import { Post } from '../services/allrequest';
import { getToken, removeToken } from '../utils/storage';

// 根据环境设置 baseURL
const env = import.meta.env.VITE_APP_ENV || import.meta.env.MODE;

// 开发和测试环境使用 /api 触发 Vite 代理，生产环境使用环境变量配置的完整地址
const getBaseURL = () => {
    if (env === 'development') {
        return '/api'; // 开发和测试环境使用代理
    }
    return import.meta.env.VITE_APP_API_URL || ''; // 生产环境使用完整URL
};

axios.defaults.baseURL = getBaseURL();
// console.log(getBaseURL(),'当前地址',import.meta.env.VITE_APP_API_URL);




/**数据加密 */
let aecdata: any
let md5: any
let md51: any
// 进行加密处理
/**生成随机数 */

function getRandomnum() {
    let uuid = encrypt.uuid()
    let md5uuid = encrypt.md5(uuid)
    return md5uuid.toLowerCase()
}

/**生成uuid */
function getUuid() {
    const UUID_STORAGE_KEY = 'admin_uuid';
    // 1. 首先检查本地存储中是否存在uuid
    let storedUuid = localStorage.getItem(UUID_STORAGE_KEY);
    // 2. 如果存在则直接使用本地存储的uuid
    if (storedUuid && storedUuid.length === 32) {
        // 验证存储的uuid格式是否正确（32位小写字符）
        if (/^[a-f0-9]{32}$/.test(storedUuid)) {
            return storedUuid;
        }
    }
    // 3. 如果不存在则生成一个新的uuid
    let uuid = encrypt.uuid();
    let md5uuid = encrypt.md5(uuid);
    let finalUuid = md5uuid.toLowerCase();

    // 4. 将新生成的uuid存储到本地
    localStorage.setItem(UUID_STORAGE_KEY, finalUuid);

    return finalUuid;
}
/**
 *  获取当前语言 用户语言（zh-CN：简体中文，en：英文）。非简体中文的默认均为英文
 */
function getCurrentLanguage(): string {
    try {
        // 2. 从浏览器navigator获取系统语言
        const browserLanguage = navigator.language || navigator.languages?.[0] || 'en';

        // 3. 判断是否为简体中文
        if (browserLanguage.toLowerCase().includes('zh-cn') ||
            browserLanguage.toLowerCase().includes('zh_cn') ||
            browserLanguage.toLowerCase() === 'zh') {
            return 'zh-CN';
        }

        // 4. 检查是否为其他中文变体，但仍返回简体中文
        if (browserLanguage.toLowerCase().startsWith('zh')) {
            // 可以根据需要调整，这里统一返回简体中文
            return 'zh-CN';
        }

        // 5. 非简体中文的默认均为英文
        return 'en';

    } catch (error) {
        // 6. 异常情况下默认返回英文
        console.warn('获取语言设置失败，使用默认语言:', error);
        return 'en';
    }
}

/**
 * 获取客户端类型
 * 1：androidAPP，2：iOSAPP，3：harmonyosAPP，4：web，
 * 5：wechatMini，6：douyinMini，7：alipayMini，8：pcAPP，99：其他
 */
function getClientType(): number {
    try {
        const ua = navigator.userAgent.toLowerCase();

        // 检测微信小程序
        if (typeof window !== 'undefined' && (window as any).__wxjs_environment === 'miniprogram') {
            return 5; // wechatMini
        }

        // 检测微信环境
        if (ua.includes('micromessenger')) {
            // 如果是微信内的H5，仍然返回web
            return 4; // web
        }

        // 检测抖音小程序
        if (typeof window !== 'undefined' && (window as any).__tt_environment === 'miniprogram') {
            return 6; // douyinMini
        }

        // 检测支付宝小程序
        if (typeof window !== 'undefined' && (window as any).my && (window as any).my.env) {
            return 7; // alipayMini
        }

        // 检测是否为移动端APP（通过自定义标识）
        if (ua.includes('androidapp')) {
            return 1; // androidAPP
        }
        if (ua.includes('iosapp')) {
            return 2; // iOSAPP
        }
        if (ua.includes('harmonyosapp')) {
            return 3; // harmonyosAPP
        }
        if (ua.includes('pcapp') || ua.includes('electron')) {
            return 8; // pcAPP
        }

        // 默认为web
        return 4; // web

    } catch (error) {
        console.warn('获取客户端类型失败，使用默认值web:', error);
        return 4; // 默认web
    }
}

/**
 * 获取操作系统类型
 * 1：Android，2：iOS，3：HarmonyOS，4：Windows，5：Linux，6：macOS，99：其他
 */
function getOsType(): number {
    try {
        const ua = navigator.userAgent.toLowerCase();
        const platform = (navigator.platform || '').toLowerCase();

        // 检测HarmonyOS（鸿蒙）
        if (ua.includes('harmonyos') || ua.includes('hongmeng')) {
            return 3; // HarmonyOS
        }

        // 检测Android
        if (ua.includes('android')) {
            return 1; // Android
        }

        // 检测iOS (iPhone, iPad, iPod)
        if (ua.includes('iphone') || ua.includes('ipad') || ua.includes('ipod') ||
            platform.includes('iphone') || platform.includes('ipad')) {
            return 2; // iOS
        }

        // 检测macOS
        if (ua.includes('mac os x') || ua.includes('macintosh') || platform.includes('mac')) {
            // 排除iOS设备
            if (!ua.includes('iphone') && !ua.includes('ipad') && !ua.includes('ipod')) {
                return 6; // macOS
            }
        }

        // 检测Windows
        if (ua.includes('windows') || platform.includes('win')) {
            return 4; // Windows
        }

        // 检测Linux
        if (ua.includes('linux') || platform.includes('linux')) {
            // 排除Android（Android也是基于Linux的）
            if (!ua.includes('android')) {
                return 5; // Linux
            }
        }

        // 其他情况
        return 99; // 其他

    } catch (error) {
        console.warn('获取操作系统类型失败，使用默认值其他:', error);
        return 99; // 默认其他
    }
}

// 🛡️ 防止重复登出的标记
let isLoggingOut = false;

// 请求拦截器，响应拦截器
// 添加请求拦截器
axios.interceptors.request.use(function (config: any) {
    // 获取时间戳
    let time: any = new Date().getTime()
    // 获取随机数
    let Randomnum = getRandomnum()

    // 获取客户端和操作系统信息（仅开发环境输出日志）
    if (import.meta.env.DEV) {
        const clientType = getClientType()
        const osType = getOsType()
        const clientMap: Record<number, string> = {
            1: 'androidAPP', 2: 'iOSAPP', 3: 'harmonyosAPP', 4: 'web',
            5: 'wechatMini', 6: 'douyinMini', 7: 'alipayMini', 8: 'pcAPP', 99: '其他'
        }
        const osMap: Record<number, string> = {
            1: 'Android', 2: 'iOS', 3: 'HarmonyOS', 4: 'Windows',
            5: 'Linux', 6: 'macOS', 99: '其他'
        }
        console.log('📱 请求头检测信息:', {
            h_client: `${clientType} (${clientMap[clientType]})`,
            h_os: `${osType} (${osMap[osType]})`,
            h_language: getCurrentLanguage(),
            userAgent: navigator.userAgent
        })
    }
    // aec加密数据
    if (config.data) {
        // console.log('走这里');
        aecdata = encrypt.aesEncrypty(config.data)
        if (config.ablen == 1) {
            // console.log('不发送数据');
        } else {
            // console.log('发送数据', config.data, aecdata);
            config.data = aecdata
            // console.log(config.data, '加密并且 重新赋值后的发送数据');

        }
    }


    let data = `pp-admin-sign-data:data=${aecdata}&nonceStr=${Randomnum}&timestamp=${time}`
    let data1 = `pp-admin-sign-data:data=&nonceStr=${Randomnum}&timestamp=${time}`
    // console.log(
    //     config.data, '加密后请求数据'
    // );
    // console.log(
    //     data, '加密前的数据 sign'
    // );
    // 获取MD5加密数据
    md5 = encrypt.md5(data).toLowerCase()
    md51 = encrypt.md5(data1).toLowerCase()
    config.headers = {
        ...config.headers,
        'h_client': String(getClientType()),      // 智能检测客户端类型
        'h_os': String(getOsType()),              // 智能检测操作系统类型
        'h_language': getCurrentLanguage(),
        'h_version': '1.0.0',
        'h_channel': 'official',
        'h_uuid': getUuid(),
        'h_timestamp': time,
        'h_nonceStr': Randomnum,
        'h_sign': config.ablen == 1 ? md51 : md5,
        'h_token': getToken() || '',
        // 'Content-Type': 'text/plain'

    }
    // 在发送请求之前做些什么  
    return config;
}, function (error) {
    console.error('请求报错', error);
    // 对请求错误做些什么
    return Promise.reject(error);
});
// 添加响应拦截器
axios.interceptors.response.use(function (response) {
    // 对响应数据做点什么
    const decryptedData = JSON.parse(encrypt.aesDecrypt(response.data))

    // 🧪 测试代码：模拟 code=10006（测试完成后请删除此行）
    // decryptedData.code = 10006;

    // 🧪 测试代码：特定接口触发 code=10006（方便测试中断恢复）
    // if (response.config.url && response.config.url.includes('/msg/edit')) {
    //     console.warn('🧪 [测试模式] 检测到 /msg/edit 请求，模拟 code=10006');
    //     decryptedData.code = 10006;
    // }

    // 🛡️ 检查返回的 code 是否为 10006 token失效（需要重新登录）
    // 注意：排除登出接口，避免死循环
    const isLogoutRequest = response.config.url && response.config.url.includes('/account/logout');

    if (decryptedData.code === 10006 && !isLogoutRequest) {
        console.warn('⚠️ 检测到 code=10006，需要重新登录');

        // 🛡️ 防止重复执行登出流程
        if (isLoggingOut) {
            console.warn('⚠️ 登出流程正在进行中，跳过重复执行');
            return decryptedData;
        }

        isLoggingOut = true;

        // 🔥 0. 保存当前路由和状态（必须在清空数据之前）
        try {
            const formStateStore = useFormStateStore();
            const currentRoute = router.currentRoute.value;

            // 只保存非登录页的路由
            if (currentRoute.path !== '/login' && currentRoute.path !== '/') {
                formStateStore.setInterruptedRoute(
                    currentRoute.fullPath,
                    currentRoute.query as Record<string, any>
                );
                console.log('✅ 已保存被中断的路由:', currentRoute.fullPath);

                // 🔥 设置中断标记，表明是因为 code=10006 退出的
                formStateStore.setInterruptedByAuth();
            }
        } catch (error) {
            console.error('❌ 保存路由状态失败:', error);
        }

        // 异步调用登出接口（不阻塞流程）
        Post('/account/logout', {}).then(() => {
            console.log('✅ 登出接口调用成功');
        }).catch((error: any) => {
            console.warn('⚠️ 登出接口调用失败:', error);
        });

        // 清空本地数据
        try {
            // 1. 首先清除动态路由（必须在清理 localStorage 之前）
            clearUserMenuRoutes();
            console.log('✅ 动态路由已清理');

            // 2. 清空 localStorage（注意：formState 由 pinia 持久化插件管理，会保留）
            removeToken();
            localStorage.removeItem('userInfo');
            localStorage.removeItem('dynamicMenus');
            localStorage.removeItem('redirectAfterLogin');
            // 注意：不要 localStorage.clear()，会清除 formState 的持久化数据

            // 3. 清空 sessionStorage
            sessionStorage.clear();

            console.log('✅ 本地数据已清空（保留表单状态）');
        } catch (error) {
            console.error('❌ 清空本地数据失败:', error);
        }

        // 4. 跳转到登录页面
        router.push('/login').then(() => {
            console.log('✅ 已跳转到登录页面');
            // 🛡️ 重置登出标记
            setTimeout(() => {
                isLoggingOut = false;
                console.log('✅ 登出流程完成，已重置标记');
            }, 1000);
        }).catch((error: any) => {
            console.error('❌ 跳转登录页面失败:', error);
            // 🛡️ 失败时也重置标记
            isLoggingOut = false;
        });

    }

    return decryptedData

}, function (error) {

    console.error('接收报错', error);

    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么
    return Promise.reject(error);
});
declare module 'axios' {
    interface AxiosInstance {
        (config: AxiosRequestConfig): Promise<any>
    }
}
export default axios
